import { CSSProperties } from 'react';

/** Oculta visualmente um elemento sem removê-lo da árvore de acessibilidade (label oculto, input nativo por trás de um botão customizado, texto de status para leitores de tela). */
export const visuallyHiddenStyle: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
};
